import { useSOP } from '@hakimo-ui/hakimo/data-access';
import { QueryResult } from '@hakimo-ui/hakimo/ui-elements';
import { SOPManager } from '../sop-manager/SOPManager';

export interface Props {
  locationId: string;
  tenantId?: string;
}

export function SOP(props: Props) {
  const { locationId, tenantId } = props;
  const queryResult = useSOP({
    locationId,
  });

  return (
    <div className="dark:bg-ondark-bg-1 bg-onlight-bg-1 rounded-lg px-1">
      <h2 className="flex h-10 items-center px-4 pt-4 font-bold">
        Standard Operating Procedure
      </h2>
      <QueryResult queryResult={queryResult} loadingText="">
        {({ sop_workflow: sopWorkflow, id }) => (
          <SOPManager
            showTitle={false}
            sopId={id ?? ''}
            sopWorkflow={sopWorkflow}
            locationId={locationId}
            tenantId={tenantId}
            fullWidth={true}
          />
        )}
      </QueryResult>
    </div>
  );
}

export default SOP;
